import { SharedModule } from '@/app/shared/shared.module';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'widget-info-box',
  imports: [SharedModule],
  templateUrl: './widget-info-box.component.html',
  styleUrl: './widget-info-box.component.less',
})
export class WidgetInfoBoxComponent {
  @Input() icon: string = 'ph-fill ph-warning';
  @Input() isErrorState: boolean = false;
  @Input() iconColor: string = '#FFC043';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() primaryButtonText: string = 'doktar_app.common.try_again_button';
  @Output() primaryButtonClick = new EventEmitter<Event>();
}
